import $ from "jquery";

if (document.querySelector(".product-description")) {

    $(".product-description__slider").slick({
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true
                }
            }
        ]
    });

    const slideBtns = document.querySelectorAll(".product-description__minislider a");
    slideBtns.forEach(slideBtn => {
        slideBtn.onclick = e => {
            e.preventDefault();
            const slideIndex = slideBtn.dataset.slide;
            $(".product-description__slider").slick("slickGoTo", slideIndex);
            slideBtns.forEach(slideBtn => slideBtn.classList.remove("product-description__active-slide"));
            slideBtn.classList.add("product-description__active-slide");
        }
    });
}